// src/app/features/aplication/pages/chat/chat.resolver.ts
import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  Router
} from '@angular/router';
import { ChatService, ChatUsuario } from '../../services/chat.service';
import { Observable, of, from } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ChatResolver implements Resolve<ChatUsuario | null> {
  constructor(
    private chatService: ChatService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<ChatUsuario | null> {
    const otherUid = route.paramMap.get('id');
    if (!otherUid) {
      this.router.navigate(['/buscar']);
      return of(null);
    }

    return from(this.chatService.getUsuario(otherUid)).pipe(
      map(user => {
        if (!user) {
          // si no existe, volvemos a buscar
          this.router.navigate(['/buscar']);
          return null;
        }
        return user;
        
      }),
      catchError(() => {
        this.router.navigate(['/buscar']);
        return of(null);
      })
    );
  }
}
